export default {
    usageManagement: {
        page: {
            title: 'System Admin Center',
            description: 'Manage user usage, model config, tool config and Langfuse Prompts',
        },
        tabs: {
            overview: 'Session Monitor',
            usage: 'User Usage',
            model: 'Model Config',
            tool: 'Tool Config',
            prompt: 'Prompt Manager',
            feedback: 'Feedback',
            payment: 'Payment Stats',
            tokenUsage: 'Token Usage',
            report: 'Statistics',
            userActivityReport: 'User Activity Report',
            assetStats: 'Asset Stats',
            documentStats: 'Document Stats',
            skill: 'Skill Manager',
            role: 'Role Management',
            companyQuota: 'Company Quota',
            userQuota: 'User Quota',
            funnel: 'User Funnel',
            oarCallLog: 'Third-Party OAR Calls',
        },
        overview: {
            metrics: {
                totalSessions: 'Total Sessions',
                avgDuration: 'Avg Duration',
                avgRounds: 'Avg Rounds',
                successRate: 'Success Rate',
                activeUsers: 'Active Users',
            },
            date: { today: 'Today', yesterday: 'Yesterday', last3days: 'Last 3 Days', last7days: 'Last 7 Days' },
            refresh: 'Refresh',
            table: {
                sessionId: 'Session ID', user: 'User', email: 'Email', ip: 'Location',
                rounds: 'Rounds', duration: 'Duration', successFailure: 'Success/Failure',
                startTime: 'Start Time', copy: 'Copy', intranet: 'Intranet',
            },
            drawer: {
                title: 'Session Detail', sessionId: 'Session ID', user: 'User', email: 'Email',
                taskId: 'Task ID', status: 'Status', ip: 'IP', duration: 'Duration', startTime: 'Start Time',
            },
            copied: 'Copied',
            searchEmail: 'Search user email',
            userTypeAll: 'All Users',
            userTypeInternal: 'Internal',
            userTypeExternal: 'External',
            userTypePlg: 'PLG',
        },
        usage: {
            config: {
                title: 'Global Config', baseTab: 'Basic Config', visitorLimit: 'Guest Daily Limit', accountLimit: 'Free User Limit',
                userTaskConcurrencyLimit: 'Paid User Concurrency Limit',
                globalTaskConcurrencyLimit: 'Paid User Global Concurrency Limit',
                freeUserTaskConcurrencyLimit: 'Free User Concurrency Limit',
                freeGlobalTaskConcurrencyLimit: 'Free User Global Concurrency Limit',
                aiCallsPerMinuteLimit: 'Model Calls Per Minute Limit',
                aiCallsCurrentCount: 'Current AI Calls (This Minute)',
                aiCallsCurrentCountUnit: 'calls',
                save: 'Save Config', hint: 'Changes will apply to all new users',
            },
            metrics: {
                totalUsage: 'Today\'s Total Usage', avgUsage: 'Avg Usage / User', avgPerUser: 'Avg {n} / user',
                activeUsers: 'Active Users', activeRate: '{n}% active rate',
                exceededUsers: 'Exceeded Users', exceededRate: '{n}% exceeded rate',
            },
            date: { today: 'Today', yesterday: 'Yesterday', last3days: 'Last 3 Days', last7days: 'Last 7 Days', placeholder: 'Select date' },
            toolbar: {
                searchPlaceholder: 'Search user email', sortField: 'Sort by', sortOrder: 'Order',
                sortByCount: 'Usage Count', sortByUserId: 'User ID', sortDesc: 'Descending', sortAsc: 'Ascending', refresh: 'Refresh',
            },
            table: {
                title: 'User Usage List', export: 'Export', user: 'User', count: 'Usage',
                limit: 'Limit', usageRate: 'Usage Rate', remaining: 'Remaining', status: 'Status', action: 'Action',
                copyEmail: 'Copy email', copyId: 'Copy ID', total: '{n} records total',
                empty: 'No user data', emptyHint: 'Waiting for users to start conversations',
            },
            status: { exceeded: 'Exceeded', warning: 'Near Limit', normal: 'Normal' },
            customLimit: {
                tag: 'Custom',
                setLimit: 'Set Limit',
                reset: 'Reset',
                dialogTitle: 'Set User Daily Limit',
                user: 'User',
                dailyLimit: 'Daily Limit',
                remark: 'Remark',
                remarkPlaceholder: 'Optional remark',
                cancel: 'Cancel',
                confirm: 'Confirm',
                setSuccess: 'User limit set successfully',
                setFailed: 'Failed to set limit',
                removeSuccess: 'Restored to global default',
                removeFailed: 'Operation failed',
            },
            export: {
                account: 'Account', userId: 'User ID', company: 'Company', count: 'Usage',
                limit: 'Limit', remaining: 'Remaining', status: 'Status',
                success: 'Export successful', filename: 'user_usage_{date}.csv',
            },
            copied: 'Copied',
        },
        report: {
            refresh: 'Refresh',
            timeWindowDefault: 'Default 5 min',
            timeWindow: {
                '5min': '5 min', '30min': '30 min', '60min': '60 min',
                today: 'Today', last7days: 'Last 7 days', last30days: 'Last 30 days',
                last3months: 'Last 3 months', last6months: 'Last 6 months', last1year: 'Last 1 year',
                minutes: '{n} min',
            },
            userStatsTitle: 'User Statistics',
            taskStatsTitle: 'Task Statistics',
            filters: {
                users: 'Filter Users',
                companies: 'Filter Companies',
                agents: 'Filter Agent Types',
                searchUser: 'Search user email',
                searchCompany: 'Search company name',
                agentTypes: {
                    disclosure: 'Disclosure',
                    patentDraft: 'Patent Draft',
                    prosecution: 'Prosecution',
                },
            },
            userMetrics: {
                dau: 'Daily Active Users (DAU)',
                mau: 'Monthly Active Users (MAU)',
                uv: 'Unique Visitors (UV)',
                pv: 'Page Views (PV)',
                avgDuration: 'Avg Session Duration',
                avgTokensPerMessage: 'Avg Tokens Per Message',
            },
            userCharts: {
                tokenTask: 'Token Consumption & Task Count Trend',
                dauMau: 'DAU/MAU Trend',
                uvPv: 'UV & PV Trend',
                avgDuration: 'Avg Session Duration Trend',
                avgConversations: 'Avg Conversations Per User Trend',
                avgTokensPerMessage: 'Avg Tokens Per Message Trend',
                tokenLabel: 'Token Consumption',
                taskLabel: 'Task Count',
                dauLabel: 'DAU',
                mauLabel: 'MAU',
                uvLabel: 'Unique Visitors (UV)',
                pvLabel: 'Page Views (PV)',
                avgDurationLabel: 'Avg Session Duration',
                avgConversationsLabel: 'Avg Conversations Per User',
                avgTokensPerMessageLabel: 'Avg Tokens Per Message',
            },
            metrics: {
                workers: 'Online Workers', activeTasks: 'Active Tasks',
                successRate: 'Success Rate', totalTasks: 'Total Tasks ({window})', avgDuration: 'Avg Duration',
            },
            chart: { title: 'Task Trend', empty: 'No trend data', total: 'Total', success: 'Success', failure: 'Failure' },
            byType: {
                title: 'Task Type Distribution', type: 'Type', total: 'Total',
                success: 'Success', failure: 'Failure', successRate: 'Success Rate', avgDuration: 'Avg Duration',
            },
            activeTasks: {
                title: 'Active Tasks', fallback: 'Fallback Mode', empty: 'No active tasks',
                worker: 'Worker', taskType: 'Task Type', runtime: 'Runtime', taskId: 'Task ID',
            },
        },
        tokenUsage: {
            title: 'User Token Usage',
            summary: { users: 'Users', totalTokens: 'Total Tokens', totalMessages: 'Total Messages', totalTasks: 'Total Tasks', avgTokensPerTask: 'Avg Tokens / Task' },
            filter: {
                timeWindowPlaceholder: 'Select time window', statusPlaceholder: 'Task status',
                statusAll: 'All', statusSuccess: 'Success', statusFailure: 'Failure',
                statusStarted: 'Running', statusPending: 'Pending',
                searchPlaceholder: 'Search user email',
                sortByTokens: 'Total Tokens', sortByMessages: 'Messages', sortByTasks: 'Tasks',
                sortDesc: 'Descending', sortAsc: 'Ascending', refresh: 'Refresh',
                expandAll: 'Expand All', collapseAll: 'Collapse All',
            },
            timeWindow: {
                '5min': '5 min', '10min': '10 min', '30min': '30 min', '1h': '1 hour',
                today: 'Today', last7days: 'Last 7 days', last30days: 'Last 30 days',
            },
            table: {
                user: 'User', totalTokens: 'Token Usage', messages: 'Messages', tasks: 'Tasks',
                conversations: 'Conversations', conversation: 'Conversation', convTokens: 'Conv Tokens', status: 'Status', ip: 'IP',
                createdAt: 'Created At', empty: 'No token usage data',
            },
            pagination: { total: '{n} users total' },
            copied: 'Copied',
        },
        model: {
            agentSection: 'Agent Model Config', agentCount: '{n} Agents',
            taskSection: 'Task-Level Overrides', taskCount: '{n} items',
            modelLabel: 'Model', modelPlaceholder: 'Search or select model',
            tempLabel: 'Temperature ({val})', tempPlaceholder: 'Temperature', maxTokensPlaceholder: 'No limit',
            maxOutput: 'Max output {n}', maxTemp: 'Max temp {n}',
            multimodal: 'Multimodal', thinking: 'Thinking',
            multimodalSupport: 'Multimodal', thinkingSupport: 'Thinking',
            fallbackModelLabel: 'Fallback Model', fallbackModelPlaceholder: 'None (no fallback on circuit break)',
            taskHeader: { task: 'Task', model: 'Model', temp: 'Temp', fallback: 'Fallback Model' },
            categories: { drafting: 'Patent Drafting', prosecution: 'OA Response', rag: 'Doc Processing', image: 'Image Analysis', general: 'General', style: 'Style Extraction' },
            save: 'Save Config', undoEdit: 'Undo Edits', resetDefault: 'Reset to Default', unsaved: 'Unsaved changes',
            loadFail: 'Failed to load model config', saveSuccess: 'Model config saved', saveFail: 'Failed to save model config',
            undoDone: 'Unsaved edits reverted',
            resetConfirmMsg: 'This will clear all custom config and restore system defaults. This cannot be undone.',
            resetConfirmTitle: 'Confirm Reset', resetConfirmBtn: 'Reset to Default', resetCancel: 'Cancel',
            resetSuccess: 'Restored to system defaults', resetFail: 'Failed to reset config',
        },
        tool: {
            baseTools: 'Base Tools (read-only)', specificTools: 'Specific Tools (configurable)',
            itemCount: '{n} items', required: 'Required', noSpecificTools: 'No specific tools for this Agent',
            save: 'Save Config', reset: 'Reset', unsaved: 'Unsaved changes',
            loadFail: 'Failed to load tool config', saveSuccess: 'Tool config saved',
            saveFail: 'Failed to save tool config', resetDone: 'Reset to last saved config',
        },
        proLimit: {
            title: 'Pro User Document Limit',
            patentDraftLimit: 'Patent Draft Limit',
            disclosureLimit: 'Disclosure Limit',
            oarLimit: 'OA Response Limit',
            unit: 'docs',
            saveSuccess: 'Pro document limits saved',
            saveFail: 'Save failed',
            loadFail: 'Load failed',
        },
        freeLimit: {
            title: 'Free User Document Limit',
            totalDocumentLimit: 'Total Document Limit',
            patentDraftLimit: 'Patent Draft Limit',
            disclosureLimit: 'Disclosure Limit',
            oarLimit: 'OA Response Limit',
            unit: 'docs',
            saveSuccess: 'Free document limits saved',
            saveFail: 'Save failed',
            loadFail: 'Load failed',
        },
        prompt: {
            config: {
                title: 'Langfuse Config',
                publicKeyLabel: 'Public Key', secretKeyLabel: 'Secret Key', hostLabel: 'Host URL (optional)',
                testConnection: 'Test Connection', loadPrompts: 'Load All Prompts',
                checkSync: 'Check Sync Status', batchPush: 'Batch Push',
                promptNamePlaceholder: 'Enter prompt name', fetch: 'Fetch',
                missingKeys: 'Please enter Public Key and Secret Key',
                connectSuccess: 'Connected!', connectFail: 'Connection failed: {msg}',
                loadSuccess: 'Loaded {n} prompts', loadFail: 'Failed to load prompts: {msg}',
                fetchFail: 'Failed to fetch prompt: {msg}', promptNameRequired: 'Please enter a prompt name',
                connectFirst: 'Please test connection first', loadFirst: 'Please load prompts first',
            },
            list: {
                title: 'Prompt Manager', count: '{n} total', searchPlaceholder: 'Search prompts...',
                loading: 'Loading prompts...', empty: 'No prompts found', reload: 'Reload',
                colName: 'Name', colType: 'Type', colLabels: 'Labels',
                colSyncStatus: 'Sync Status', colActions: 'Actions',
                view: 'View', push: 'Push', synced: 'Synced', unchecked: 'Unchecked',
            },
            sync: {
                same: 'Synced', different: 'Outdated', frontendOnly: 'Pending', backendOnly: 'Backend only',
                checkDone: 'Sync check done! Total {total} - Synced: {same}, Outdated: {diff}, Pending: {pending}, Backend only: {backend}',
                checkFail: 'Sync check failed: {msg}',
            },
            push: {
                dialogTitle: 'Push Prompts to Backend', selected: '{n} prompts selected for push',
                overwrite: 'Overwrite existing prompts',
                pushing: 'Pushing in batches, up to 5 per batch...',
                cancel: 'Cancel', pushBtn: 'Push ({n})', nothingToPush: 'No prompts need to be pushed',
                batchInfo: 'Pushing batch {cur}/{total} ({n} prompts)...',
                batchDone: 'Batch {n} done! Success: {success}, Failed: {fail}',
                allDone: 'All batches done! Total - Success: {success}, Failed: {fail}, Skipped: {skip}',
                pushFail: 'Push failed: {msg}',
                singleSuccess: '{name} pushed successfully!', singleSkipped: '{name} push skipped',
                singleFail: 'Failed to push {name}: {msg}',
            },
            detail: {
                name: 'Name', type: 'Type', version: 'Version', labels: 'Labels',
                content: 'Prompt Content:', fetchFail: 'Failed to fetch prompt detail: {msg}',
            },
        },
        assetStats: {
            totalTemplates: 'Total Templates',
            totalInstructions: 'Total Instructions',
            totalStyles: 'Total Styles',
            startDate: 'Start Date',
            endDate: 'End Date',
            searchUser: 'Search User Email',
            user: 'User',
            templates: 'Templates',
            instructions: 'Instructions',
            styles: 'Styles',
            all: 'All',
            today: 'Today',
            yesterday: 'Yesterday',
            last7days: 'Last 7 Days',
            last30days: 'Last 30 Days',
            refresh: 'Refresh',
            tableTitle: 'Asset Stats',
            empty: 'No data',
            copied: 'Copied',
            total: '{n} records total',
        },
        documentStats: {
            docGroup: 'Documents',
            assetGroup: 'Assets',
            totalDocuments: 'Total Documents',
            totalExports: 'Total Exports',
            startDate: 'Start Date',
            endDate: 'End Date',
            searchUser: 'Search User Email',
            searchUserBatch: 'Email or User ID, comma separated',
            searchCompany: 'Search company name',
            user: 'User',
            userId: 'User ID',
            company: 'Company',
            email: 'Email',
            disclosure: 'Disclosure',
            patentDraft: 'Patent Draft',
            prosecution: 'Prosecution',
            totalCount: 'Total Docs',
            exportCount: 'Exports',
            templateCount: 'Templates',
            instructionCount: 'Instructions',
            styleCount: 'Styles',
            folderCount: 'Folders',
            totalTemplates: 'Total Templates',
            totalInstructions: 'Total Instructions',
            totalStyles: 'Total Styles',
            totalFolders: 'Total Folders',
            all: 'All',
            today: 'Today',
            yesterday: 'Yesterday',
            last7days: 'Last 7 Days',
            last30days: 'Last 30 Days',
            custom: 'Custom',
            refresh: 'Refresh',
            tableTitle: 'Asset Stats',
            empty: 'No data',
            copied: 'Copied',
            total: '{n} records total',
            userTypeAll: 'All Users',
            userTypeInternal: 'Internal',
            userTypeExternal: 'External',
            userTypePlg: 'PLG',
            filterTimeRange: 'Time Range',
            filterUser: 'User Filter',
            search: 'Search',
            reset: 'Reset',
            bulkSearch: 'Bulk Search',
            bulkSearchHint: 'One email per line, or separated by commas/spaces',
            uploadFile: 'Upload File',
            uploadFileHint: 'Supports .xlsx / .xls / .csv, first column as emails',
            dropZoneText: 'Drag & drop Excel / CSV file here, or click to upload',
            emailInputPlaceholder: 'Type an email and press Enter',
            recognizedCount: '{n} emails recognized',
            clearAll: 'Clear All',
            cancel: 'Cancel',
            emailCount: '{n} emails',
            importedCount: '{n} emails imported',
            clearImport: 'Clear',
            export: 'Export',
            exportAll: 'Export All',
            exportSelected: 'Export Selected',
            selectedCount: '{n} selected',
            exportSuccess: 'Export successful',
            parseError: 'Failed to parse file',
            noEmailFound: 'No valid emails found',
        },
        email: {
            sendEmail: 'Send Email',
            dialogTitle: 'Send Operational Email',
            recipientCount: 'Will send to {n} users',
            promptLabel: 'Email Requirements',
            promptPlaceholder: 'Describe the email content you need, e.g.: Write a product update email introducing our new AI writing feature...',
            promptRequired: 'Please enter email requirements',
            generate: 'Generate Email',
            generating: 'Generating...',
            generateFailed: 'AI generation failed, please retry',
            aiGenerate: 'AI Generate',
            emailInfo: 'Email Info',
            recipients: 'recipients',
            templates: 'Templates',
            noTemplates: 'No templates yet. Generate with AI and save as template.',
            saveAsTemplate: 'Save as Template',
            templateName: 'Template Name',
            templateNamePlaceholder: 'Enter template name',
            templateDesc: 'Description',
            templateDescPlaceholder: 'Optional, briefly describe the template',
            templateNameRequired: 'Please enter template name',
            templateSaved: 'Template saved',
            templateSaveFailed: 'Failed to save template',
            templateDeleted: 'Template deleted',
            templateDeleteFailed: 'Failed to delete template',
            save: 'Save',
            selectTemplate: 'Select a template...',
            deleteTemplate: 'Delete Template',
            bodyContent: 'Email Body',
            bodyPlaceholder: 'HTML body fragment — will be wrapped in the branded email shell...',
            subject: 'Subject',
            subjectPlaceholder: 'Enter email subject',
            content: 'Content',
            contentRequired: 'Please fill in subject and content',
            preview: 'Preview',
            source: 'Source',
            back: 'Back',
            cancel: 'Cancel',
            confirmSend: 'Confirm Send',
            sending: 'Sending...',
            sendSuccess: 'Email task submitted',
            sendFailed: 'Failed to send email',
            emailed: 'Emailed',
            sent: 'Sent',
            opened: 'Opened',
            notEmailed: 'Not Emailed',
            emailStatusAll: 'Email Status',
            emailStatusSent: 'Sent',
            emailStatusNotSent: 'Not Sent',
            noEmailWarning: 'The following users have no email and will be skipped',
            previewEmpty: 'Enter requirements and click Generate. Email preview will appear here.',
            sendHistory: 'Send History',
            sendHistoryDesc: 'View all email campaigns and recipient status',
            noHistory: 'No emails sent yet',
        },
        feedback: {
            title: 'User Feedback Management',
            totalCount: '{n} total',
            searchEmail: 'Search user email',
            statusPlaceholder: 'Status',
            categoryPlaceholder: 'Category',
            priorityPlaceholder: 'Priority',
            refresh: 'Refresh',
            emptyText: 'No feedback data',
            colUser: 'User',
            colTitle: 'Title',
            colCategory: 'Category',
            colStatus: 'Status',
            colPriority: 'Priority',
            colTime: 'Submitted',
            copyEmail: 'Copy email',
            copyId: 'Copy ID',
            copyProjectId: 'Copy Project ID',
            copied: 'Copied',
            paginationTotal: '{n} total',
            delete: 'Delete',
            deleteConfirm: 'Are you sure you want to delete this feedback? This cannot be undone.',
            batchDeleteConfirm: 'Are you sure you want to delete {n} selected feedback items? This cannot be undone.',
            batchDelete: 'Batch Delete',
            selectedCount: '{n} selected',
            deleteTitle: 'Delete Feedback',
            deleteBtn: 'Delete',
            deleteCancel: 'Cancel',
            deleteSuccess: 'Feedback deleted',
            colAction: 'Action',
            status: {
                pending: 'Pending',
                processing: 'Processing',
                resolved: 'Resolved',
                closed: 'Closed',
            },
            category: {
                bug: 'Bug',
                suggestion: 'Suggestion',
                feature_request: 'Feature Request',
                other: 'Other',
            },
            priority: {
                high: 'High',
                medium: 'Medium',
                low: 'Low',
            },
            drawer: {
                statusLabel: 'Status',
                priorityLabel: 'Priority',
                statusPending: 'Pending',
                statusProcessing: 'Processing',
                statusResolved: 'Resolved',
                statusClosed: 'Closed',
                priorityHigh: 'High',
                priorityMedium: 'Medium',
                priorityLow: 'Low',
                adopt: 'Adopt',
                noMessages: 'No messages yet',
                replyPlaceholder: 'Type your reply, Enter for new line, Ctrl+Enter to send...',
                replyHint: 'Ctrl+Enter to send',
                sendReply: 'Send Reply',
                statusLabelPending: 'Pending',
                statusLabelProcessing: 'Processing',
                statusLabelResolved: 'Resolved',
                statusLabelClosed: 'Closed',
                categoryBug: 'Bug',
                categorySuggestion: 'Suggestion',
                categoryFeatureRequest: 'Feature Request',
                categoryOther: 'Other',
                priorityHighLabel: 'High Priority',
                priorityMediumLabel: 'Medium Priority',
                priorityLowLabel: 'Low Priority',
            },
        },
        modelConfig: {
            groupLabel: 'Config Group',
            activeTag: 'Active',
            create: 'Create',
            rename: 'Rename',
            delete: 'Delete',
            createDialogTitle: 'Create Config Group',
            nameLabel: 'Name',
            namePlaceholder: 'e.g. GPT Priority, Economy Mode',
            copyFromLabel: 'Copy From',
            copyFromPlaceholder: 'None (empty config)',
            cancel: 'Cancel',
            createBtn: 'Create',
            renameDialogTitle: 'Rename Config Group',
            renamePlaceholder: 'New name',
            save: 'Save',
            switchSuccess: 'Config group switched',
            switchFail: 'Failed to switch config group',
            nameRequired: 'Please enter a group name',
            createSuccess: 'Config group created',
            createFail: 'Creation failed',
            updateSuccess: 'Config group updated',
            updateFail: 'Update failed',
            deleteConfirmMsg: 'Are you sure you want to delete config group "{name}"? This cannot be undone.',
            deleteConfirmTitle: 'Delete Config Group',
            deleteConfirmBtn: 'Delete',
            deleteSuccess: 'Config group deleted',
            deleteFail: 'Deletion failed',
        },
        langfuse: {
            connectionFallback: 'Connection failed',
            connectionFailMsg: 'Connection failed: {msg}',
            connectFirst: 'Please test connection first',
            promptNameRequired: 'Please enter a prompt name',
        },
        payment: {
            totalCount: 'Total Count',
            totalAmount: 'Total Amount (USD)',
            records: 'Payment Records',
            total: '{n} total',
            searchPlaceholder: 'Search email/plan',
            startDate: 'Start Date',
            endDate: 'End Date',
            refresh: 'Refresh',
            emptyText: 'No payment records',
            user: 'User',
            plan: 'Plan',
            amount: 'Amount',
            cycle: 'Cycle',
            time: 'Time',
            monthly: 'Monthly',
            yearly: 'Yearly',
            loadFailed: 'Failed to load payment records',
            statsFailed: 'Failed to load stats',
        },
        oarCallLog: {
            totalCalls: 'Total Calls',
            summaryTitle: 'Monthly Summary (Reconciliation)',
            allMonths: 'All Months',
            summaryByService: 'Breakdown by Service',
            service: 'Service',
            subtotal: 'Subtotal',
            records: 'Call Records',
            total: '{n} records',
            searchPlaceholder: 'Search app no. / user ID',
            projectIdPlaceholder: 'Filter by project ID',
            allServices: 'All Services',
            allStatuses: 'All Statuses',
            startDate: 'Start Date',
            endDate: 'End Date',
            refresh: 'Refresh',
            emptyText: 'No call records',
            applicationNumber: 'App No.',
            userId: 'User ID',
            projectId: 'Project ID',
            status: 'Status',
            retryCount: 'Retries',
            responseCode: 'Response Code',
            resultLength: 'Result Length',
            errorMessage: 'Error',
            createdAt: 'Created At',
            loadFailed: 'Failed to load call records',
            statsFailed: 'Failed to load stats',
        },
        skill: {
            patentOffice: 'Patent Office',
            mode: 'Mode',
            modeAgent: 'Full Mode',
            modeCopilot: 'Copilot Mode',
            disclosure: 'Disclosure',
            patentDraft: 'Patent Draft',
            prosecution: 'Prosecution',
            empty: 'No data',
            loadFailed: 'Load failed',
            save: 'Save',
            reset: 'Reset',
            saveSuccess: 'Saved successfully',
            saveFailed: 'Save failed',
            editor: { edit: 'Edit', split: 'Split', preview: 'Preview' },
        },
        skillDb: {
            title: 'Skill Management (DB)',
            create: 'Create Skill',
            searchPlaceholder: 'Search by name or description',
            draftingType: 'Drafting Type',
            patentOffice: 'Patent Office',
            category: 'Category',
            all: 'All',
            colName: 'Name',
            colType: 'Type',
            colOffice: 'Office',
            colField: 'Tech Field',
            colCategory: 'Category',
            colUsage: 'Usage',
            colActions: 'Actions',
            edit: 'Edit',
            duplicate: 'Duplicate',
            delete: 'Delete',
            editTitle: 'Edit Skill',
            createTitle: 'Create Skill',
            fieldName: 'Name',
            fieldCategory: 'Category',
            fieldPublic: 'Public',
            fieldDescription: 'Description',
            fieldDraftingType: 'Drafting Type',
            fieldPatentOffice: 'Patent Office',
            fieldTechField: 'Technical Field',
            fieldContent: 'Content (Markdown)',
            cancel: 'Cancel',
            save: 'Save',
            loadFailed: 'Failed to load skills',
            createSuccess: 'Skill created',
            updateSuccess: 'Skill updated',
            saveFailed: 'Save failed',
            deleteTitle: 'Delete',
            deleteConfirm: 'Are you sure to delete skill "{name}"?',
            deleteSuccess: 'Deleted',
            duplicateSuccess: 'Duplicated',
            duplicateFailed: 'Duplicate failed',
            tabBasic: 'Basic Info',
            colRefs: 'Refs',
            refCreate: 'Add Reference',
            refEditTitle: 'Edit Reference',
            refCreateTitle: 'Add Reference',
            refUpdateSuccess: 'Reference updated',
            refCreateSuccess: 'Reference created',
            refDeleteConfirm: 'Are you sure to delete reference "{name}"?',
        },
        role: {
            searchPlaceholder: 'Search email',
            search: 'Search',
            assign: 'Assign Role',
            email: 'Email',
            role: 'Role',
            assignedBy: 'Assigned By',
            remark: 'Remark',
            createdAt: 'Created At',
            action: 'Action',
            remove: 'Remove',
            assignTitle: 'Assign Role',
            cancel: 'Cancel',
            confirm: 'Confirm',
        },
        funnel: {
            title: 'User Conversion Funnel',
            refresh: 'Refresh',
            metrics: {
                anonymous: 'Anonymous Users',
                free: 'Free Users',
                pro: 'Pro Users',
                enterprise: 'Enterprise Users',
            },
            chart: {
                funnelTitle: 'Conversion Funnel',
                empty: 'No data available',
            },
            table: {
                title: 'Conversion Details',
                level: 'Level',
                count: 'Users',
                percentage: 'Share',
                conversionRate: 'Conversion',
                churn: 'Churn',
                baseline: 'Baseline',
            },
            timeWindow: {
                all: 'All',
                '60min': '60 min',
                today: 'Today',
                last7days: 'Last 7 days',
                last30days: 'Last 30 days',
                last3months: 'Last 3 months',
                last6months: 'Last 6 months',
                last1year: 'Last 1 year',
            },
        },
        userDetail: {
            title: 'User Detail',
            userId: 'User ID',
            company: 'Company',
            sectionDocStats: 'Document Statistics',
            sectionTokenUsage: 'Token Usage',
            sectionSessions: 'Session History',
            sectionUsageLimits: 'Usage Limits',
            disclosure: 'Disclosure',
            patentDraft: 'Patent Draft',
            prosecution: 'Prosecution',
            totalDocs: 'Total Docs',
            exports: 'Exports',
            templates: 'Templates',
            instructions: 'Instructions',
            styles: 'Styles',
            folders: 'Folders',
            totalTokens: 'Total Tokens',
            totalMessages: 'Total Messages',
            taskCount: 'Tasks',
            conversationId: 'Conversation',
            tokens: 'Tokens',
            messages: 'Messages',
            rounds: 'Rounds',
            duration: 'Duration',
            successFailure: 'Success / Fail',
            startTime: 'Start Time',
            chatCount: 'Chat Count',
            limit: 'Limit',
            customLimit: 'Custom Limit',
            remaining: 'Remaining',
            exceeded: 'Exceeded',
            normal: 'Normal',
            noData: 'No data',
            copied: 'Copied',
        },
        userQuota: {
            title: 'User Document Quota Management',
            description: 'Add extra document creation quota for specific users on top of global config',
            searchPlaceholder: 'Search Email',
            addQuota: 'Add Quota',
            editQuota: 'Edit Quota',
            userId: 'User ID',
            email: 'Email',
            documentType: 'Document Type',
            quotaAdjustment: 'Extra Quota',
            remark: 'Remark',
            createdAt: 'Created At',
            actions: 'Actions',
            edit: 'Edit',
            delete: 'Delete',
            save: 'Save',
            cancel: 'Cancel',
            noData: 'No user quota data',
            confirmDelete: 'Are you sure you want to delete this user document quota?',
            confirmDeleteTitle: 'Confirm Delete',
            deleteSuccess: 'Deleted successfully',
            saveSuccess: 'Saved successfully',
            patent_draft: 'Patent Draft',
            disclosure: 'Disclosure',
            prosecution: 'Prosecution',
            total: 'Total Documents',
            adjustmentHint: 'Extra document count on top of global config',
            userIdRequired: 'Please enter User ID',
            emailRequired: 'Please enter user email',
            documentTypeRequired: 'Please select document type',
            adjustmentRequired: 'Please enter extra quota',
        },
    },
};
